import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';
import { DevisService, DevisRequest } from '../../services/devis.service';

@Component({
  selector: 'app-devis-prevoyance-obseques',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, PageLayoutComponent],
  templateUrl: './devis-prevoyance-obseques.component.html',
  styleUrl: './devis-prevoyance-obseques.component.css'
})
export class DevisPrevoyanceObsequesComponent {
  title = 'Devis Assurance Obsèques';
  subtitle = 'Anticipez et soulagez vos proches des démarches';
  phoneNumber = '07 57 93 35 00';
  heroImage = 'assets/static_pages_images/obseques.jpg';
  breadcrumbs = [{ label: 'Devis Obsèques', link: undefined }];
  prevPage = { title: 'Assurance Prévoyance Obsèques', link: '/assurance-prevoyance-obseque' };
  nextPage = { title: 'Contactez-nous', link: '/contact' };

  // Tab navigation
  devisTabs = [
    { label: 'Santé Particulier', route: '/devis-sante-particulier', icon: 'pi-user' },
    { label: 'Santé Professionnelle', route: '/devis-sante-professionnelle', icon: 'pi-briefcase' },
    { label: 'Emprunteur', route: '/devis-emprunteur', icon: 'pi-home' },
    { label: 'Prévoyance GAV', route: '/devis-prevoyance-gav', icon: 'pi-shield' },
    { label: 'Prévoyance IJH', route: '/devis-prevoyance-ijh', icon: 'pi-building' },
    { label: 'Prévoyance Obsèques', route: '/devis-prevoyance-obseques', icon: 'pi-heart' },
    { label: 'Prévoyance Décès', route: '/devis-prevoyance-deces', icon: 'pi-lock' },
    { label: 'Animaux', route: '/devis-animaux', icon: 'pi-star' },
    { label: 'PNO', route: '/devis-pno', icon: 'pi-building' }
  ];

  devisForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;
  errorMessage = '';

  civilites = ['M.', 'Mme', 'Mlle'];
  pays = ['France', 'Belgique', 'Suisse', 'Luxembourg', 'Monaco'];

  constructor(private fb: FormBuilder, private devisService: DevisService) {
    this.devisForm = this.fb.group({
      civilite: ['', Validators.required],
      nom: ['', [Validators.required, Validators.minLength(2)]],
      prenom: ['', [Validators.required, Validators.minLength(2)]],
      dateNaissance: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: ['', [Validators.required, Validators.email]],
      profession: ['', Validators.required],
      adresse: ['', Validators.required],
      codePostal: ['', [Validators.required, Validators.pattern(/^[0-9]{5}$/)]],
      ville: ['', Validators.required],
      pays: ['France', Validators.required]
    });
  }

  onSubmit() {
    if (this.devisForm.valid) {
      this.isSubmitting = true;
      this.errorMessage = '';

      const formValues = this.devisForm.value;
      const devisRequest: DevisRequest = {
        devis_type: 'Prévoyance Obsèques',
        civilite: formValues.civilite,
        nom: formValues.nom,
        prenom: formValues.prenom,
        date_naissance: formValues.dateNaissance,
        telephone: formValues.telephone,
        email: formValues.email,
        profession: formValues.profession,
        adresse: formValues.adresse,
        code_postal: formValues.codePostal,
        ville: formValues.ville,
        pays: formValues.pays
      };

      this.devisService.submitDevis(devisRequest).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          if (response.success) {
            this.isSubmitted = true;
          } else {
            this.errorMessage = response.message;
          }
        },
        error: (error) => {
          this.isSubmitting = false;
          this.errorMessage = error.error?.detail || 'Une erreur est survenue lors de l\'envoi de votre demande. Veuillez réessayer.';
          console.error('Error submitting devis:', error);
        }
      });
    } else {
      this.devisForm.markAllAsTouched();
    }
  }
}
